import { ExternalLink } from "@/components/ExternalLink";
import { siteLinks } from "@/config/branding";
import type { WizardState } from "@/config/horizonscanning/types";

interface EmailStepProps {
  state: WizardState;
  error: string | null;
  onChange: (patch: Partial<WizardState>) => void;
}

export function EmailStep({ state, error, onChange }: EmailStepProps) {
  return (
    <div className="flex flex-col gap-5">
      <label className="text-sm font-medium text-ink-soft">
        Work email
        <input
          type="email"
          inputMode="email"
          autoComplete="email"
          className="r1-field mt-1"
          placeholder="you@company.com"
          value={state.email}
          onChange={(e) => onChange({ email: e.target.value })}
          aria-invalid={!!error}
        />
      </label>
      <p className="text-sm text-ink-muted">
        By continuing you agree to our{" "}
        <ExternalLink href={siteLinks.terms} className="font-medium text-brand-600 underline">
          Terms
        </ExternalLink>{" "}
        and{" "}
        <ExternalLink href={siteLinks.privacy} className="font-medium text-brand-600 underline">
          Privacy Policy
        </ExternalLink>
        , and that RequirementONE may email a digest to this address and to recipients you add later.
      </p>
    </div>
  );
}
